import { createContext } from "react";
import { feedbacksInitialState } from "./feedbacksInitialState";


const FeedbacksContext = createContext(feedbacksInitialState)

export default FeedbacksContext